import Style from "./style"

const DefaultButton = ({
    children, clickEvent,
    small, deactive, caution
}) => {

    return (
        <Style.Button onClick={!deactive ? clickEvent : null} $small={small} $deactive={deactive} $caution={caution}>{children}</Style.Button>
    )
}

export default DefaultButton